import { Box, Paper } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import { useStyles } from "../styles";

export default function MxheroSharesSkeleton() {
  const classes = useStyles();

  return (
    <Paper className={classes.container}>
      <Box mt={1} display="flex" flexDirection="column" gridGap="1rem">
        <Box mb="1rem" display="flex" flexDirection="column" gridGap="2rem">
          <Box className={classes.inputContainer}>
            <Skeleton width={150} height={20} style={{ marginBottom: 10 }} />
            <Skeleton
              height={56}
              width="100%"
              style={{ maxWidth: "25rem" }}
              variant="rect"
            />
          </Box>

          {/* Retention Options - Radio Buttons */}
          <Box width="100%">
            <Skeleton width={180} height={20} style={{ marginBottom: 10 }} />
            <Box display="flex" flexDirection="row" style={{ gap: "2rem" }}>
              <Box display="flex" alignItems="center" style={{ height: 32 }}>
                <Skeleton
                  variant="circle"
                  width={16}
                  height={16}
                  style={{ marginRight: 8 }}
                />
                <Skeleton width={100} height={16} />
              </Box>
              <Box display="flex" alignItems="center" style={{ height: 32 }}>
                <Skeleton
                  variant="circle"
                  width={16}
                  height={16}
                  style={{ marginRight: 8 }}
                />
                <Skeleton width={100} height={16} />
              </Box>
            </Box>
          </Box>

          {/* Authentication Options - Checkboxes */}
          <Box width="100%">
            <Skeleton width={200} height={20} style={{ marginBottom: 2 }} />

            {/* External Authentication */}
            <Box style={{ marginBottom: 2 }}>
              <Skeleton width={180} height={20} style={{ marginBottom: 2 }} />
              <Box display="flex" flexDirection="column">
                {[1, 2, 3].map(i => (
                  <Box
                    key={`ext-${i}`}
                    display="flex"
                    alignItems="center"
                    style={{ height: 32 }}
                  >
                    <Skeleton
                      variant="rect"
                      width={16}
                      height={16}
                      style={{ marginRight: 11 }}
                    />
                    <Skeleton width={120} height={16} />
                  </Box>
                ))}
              </Box>
            </Box>

            {/* Organization Authentication */}
            <Box mt="1rem">
              <Skeleton width={200} height={20} style={{ marginBottom: 2 }} />
              <Box style={{ marginBottom: 2 }}>
                <Skeleton width={200} height={20} style={{ marginBottom: 2 }} />
                <Box display="flex" flexDirection="column">
                  {[1, 2, 3].map(i => (
                    <Box
                      key={`org-${i}`}
                      display="flex"
                      alignItems="center"
                      style={{ height: 32 }}
                    >
                      <Skeleton
                        variant="rect"
                        width={16}
                        height={16}
                        style={{ marginRight: 11 }}
                      />
                      <Skeleton width={120} height={16} />
                    </Box>
                  ))}
                </Box>
              </Box>
            </Box>
          </Box>

          {/* End User Permissions - Checkboxes with descriptions */}
          <Box width="100%">
            <Skeleton width={180} height={20} />
            <Skeleton width="90%" height={16} style={{ marginTop: 4 }} />

            <Box
              mt="1.2rem"
              mb=".5rem"
              ml=".5rem"
              display="flex"
              flexDirection="column"
            >
              <Box mb="1rem">
                <Skeleton width={150} height={16} />
              </Box>

              <Box
                display="flex"
                flexDirection="column"
                style={{ gap: "1.4rem" }}
              >
                {[1, 2, 3, 4, 5].map(i => (
                  <Box key={`perm-${i}`} display="flex" alignItems="flex-start">
                    <Skeleton
                      variant="rect"
                      width={16}
                      height={16}
                      style={{ marginTop: 3 }}
                    />
                    <Box ml=".8rem" flex={1}>
                      <Skeleton
                        width="70%"
                        height={16}
                        style={{ marginBottom: 4 }}
                      />
                      <Skeleton width="90%" height={12} />
                    </Box>
                  </Box>
                ))}
              </Box>
            </Box>
          </Box>
        </Box>

        {/* Submit Button */}
        <Skeleton
          height={36}
          width={150}
          variant="rect"
          style={{ borderRadius: 4 }}
        />
      </Box>
    </Paper>
  );
}
